import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Popup, SearchInput } from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';

import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class JoinLiveClassPopup extends Component {
  getBtnProps = (title) => {
    const { model } = this.props;
    const { hidePopup, copyURL } = model.store.joinLiveClass;
    return {
      text: title,
      onClick: title === 'Cancel' ? hidePopup : copyURL,
      key: title,
      icon: title === 'Cancel' ? { type: 'close' } : { type: 'contentCopy' },
      className: title === 'Cancel' ? s.cancelBtn : s.copyButton
    };
  };

  render() {
    const { model } = this.props;
    const { isPopupVisible } = model.store.joinLiveClass;

    if (!isPopupVisible) {
      return null;
    }

    const { theme } = this.props;
    const { contentName, joinURL, hidePopup } = model.store.joinLiveClass;

    return (
      <Popup
        onCloseClick={hidePopup}
        header={{
          title: (
            <div className={s.header}>
              Teach&nbsp;
              {contentName}
            </div>
          )
        }}
        showPopup={true}
        footer={[
          { ...this.getBtnProps('Cancel') },
          { ...this.getBtnProps('Copy URL'), type: 'filled' }
        ]}
      >
        <div className={s.info(theme)}>Share this URL with learners to join your classroom</div>
        <div className={s.urlContainer}>
          <div className={s.urlInput}>
            <SearchInput placeholder="Join Class URL" value={joinURL} showSearchIcon={false} />
          </div>
        </div>
      </Popup>
    );
  }
}

export default JoinLiveClassPopup;
